import { useMemo } from 'react';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import { getBgColor, getIcon } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';
import OcrIndicator from '../split_line_item/OcrIndicator';

const PoNumber = () => {
  const invoice = useContextSelector(InvoiceContext, (value) => value.invoice);
  const ocrResponse = useContextSelector(InvoiceContext, (value) => value.ocrResponse);
  const initialInvoice = useContextSelector(InvoiceContext, (value) => value.initialInvoice);
  const handleHoverOcrField = useContextSelector(
    InvoiceContext,
    (value) => value.handleHoverOcrField
  );
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );

  const informations = useMemo(
    () =>
      initialInvoice?.ocrGenerated && !invoice?.poNum && !isInvoiceEditDisabled
        ? [
            'OCR record not matched to an existing PO. If an existing PO is available, search and reassign this invoice to it using the Change PO Assignment feature.',
          ]
        : [],
    [initialInvoice?.ocrGenerated, invoice?.poNum, isInvoiceEditDisabled]
  );

  const isEdited = useMemo(
    () => ocrResponse.purchaseOrder?.value !== invoice?.poNum,
    [invoice.poNum, ocrResponse.purchaseOrder?.value]
  );

  return (
    <>
      <PopUp
        content={
          <div className="flex flex-col gap-2">
            <PopUpContentWrapper type="Information" contents={informations} />
          </div>
        }
        show={informations.length !== 0}
        popupAlign={{ horizontal: 'center', vertical: 'bottom' }}
        anchorAlign={{ horizontal: 'right', vertical: 'top' }}
      >
        <div className={`p-1 ${getBgColor([], [], informations)} text-[13px]`}>
          <p className="font-bold flex items-center pb-1">
            PO #
            <span className=" flex items-center flex-grow">
              <div>{getIcon([], [], informations)}</div>
              <div className="ml-auto">
                {initialInvoice?.ocrGenerated && ocrResponse.purchaseOrder?.confidence && (
                  <div className="ml-auto">
                    <OcrIndicator
                      isEdited={isEdited}
                      ocrConfidence={ocrResponse.purchaseOrder?.confidence}
                      onHover={() => handleHoverOcrField('purchaseOrder')}
                    />
                  </div>
                )}
              </div>
            </span>
          </p>
          <p title={invoice?.poNum} className="min-h-[28px]">
            {invoice?.poNum}
          </p>
        </div>
      </PopUp>
    </>
  );
};

export default PoNumber;
